<template>
  <div class="table-container">
    <h3 class="table-container__title">{{ groupData.test_name }}</h3>
    <p class="table-container__group">
      Группа: <span>{{ groupData.group_name }}</span>
    </p>
    <p class="table-container__quantity">
      Количество вопросов:
      <span v-if="stats.length">{{ stats[0].allAnswers }}</span>
    </p>
    <div class="table">
      <div class="table__header">
        <div class="row">
          <span>ФИО студента</span>
          <span>Верных ответов</span>
          <span>Неверных ответов</span>
          <span>Время на решение</span>
          <span></span>
        </div>
      </div>
      <div :class="['table__body', {'table__body--error': error}]">
        <template v-if="!error">
          <div class="row" v-for="(stat, index) of stats" :key="index">
            <span>{{ stat.name }}</span>
            <span>{{ stat.correctAnswers }}</span>
            <span>{{ stat.allAnswers - stat.correctAnswers }}</span>
            <span>{{ stat.time }}</span>
            <button class="cell-button" @click="$emit('change', stat)">
              <i class="fas fa-eye"></i>
            </button>
          </div>
        </template>
        <template v-else>
          <span>{{ error }}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stats: Array,
    groupData: Object,
    error: String,
  },
};
</script>

<style lang="scss">
.table-container {
  overflow: hidden;
  padding: 20px 10px 10px 10px;
  background-color: $brand-clr-1;
  border-radius: 30px;
  transition: all 0.3s ease-in;
  position: absolute;
  height: 100%;
  width: 100%;
  display: grid;
  row-gap: 10px;
  grid-template-rows: max-content max-content max-content 1fr;
  backface-visibility: hidden;
  color: $basic-white;
}
.table-container__title {
  color: $basic-white;
  margin: 0;
}
.table-container__group,
.table-container__quantity {
  margin: 0;
}
.table {
  overflow: hidden;
  display: grid;
  grid-template-rows: max-content 1fr;
  width: 100%;
  height: 100%;
}
.difficulty-text {
  color: $regular-text-clr;
  display: grid;
  column-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr;
  max-width: max-content;
  align-items: center;
}
.difficulty-text__value {
  padding: 5px 10px;
}
.row {
  justify-items: center;
  align-items: center;
  text-align: center;
  display: grid;
  column-gap: 10px;
  padding: 10px;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  border-bottom: 1px solid darken($color: $brand-clr-1, $amount: 10%);
}
.table__header {
  padding-right: 6px;
  font-weight: bold;
  background-color: $brand-clr-1;
  position: relative;
  z-index: 5;
  border-bottom: 2px solid darken($color: $brand-clr-1, $amount: 10%);
}
.table__header .row {
  border: none;
}
.table__body {
  width: 100%;
  height: 100%;

  overflow-y: auto;
}
.table__body--error{
    display: flex;
    align-items: center;
    justify-content: center;
}
.cell-button {
  cursor: pointer;
  transition-duration: 0.3s;
  transition-property: color;
  color: $placeholder-text-clr;
  font-size: 20px;
  &:hover {
    color: $basic-white;
  }
}
@media (max-width: 800px) {
  .table-container {
    .table__body {
      height: 370px;
    }
  }
}
</style>